<template>
  <div class="box4">
    <pageTitle
      title="对标就业需求&nbsp;&nbsp;掌握前沿技术"
      text="赋能未来，打造您的技术核心竞争力"
    />
    <div class="box4-btm-box">
      <div class="box4-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject"
          :key="index"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)" ref="item">
            <div class="title">
              <p v-show="item.stage">{{ item.stage }}</p>
              {{ item.title }}
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div v-if="item.project">
            <div
              class="course-content"
              :class="{ 'show-answer': cur == index && showAnswer }"
            >
              <div class="line"></div>
              <div class="sel-wrapper">
                <span v-for="(pro, i) in item.project" :key="i" class="sel" :class="{'active': selCur == i}" @click="changeSelCur(i)">{{pro.title}}</span>任学其中一个项目
              </div>
              <div v-for="(pro, i) in item.project" :key="i" v-show="selCur == i">
                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/01.png"
                    alt
                  />主讲内容
                </div>
                <div class="main-content">
                  <div
                    :class="'main-text2'"
                    v-for="i in pro.content"
                    :key="i"
                  >
                    -{{ i }}<br />
                  </div>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/02.png"
                    alt
                  />特色亮点
                </div>
                <div class="main-text">
                  <p v-for="j in pro.light" :key="j">{{ j }}</p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/03.png"
                    alt
                  />可掌握的核心能力
                </div>
                <div class="main-text">
                  <p v-for="k in pro.ability" :key="k">{{ k }}</p>
                </div>
              </div>
              
            </div>
          </div>
          <div v-else>
            <div
              class="course-content"
              :class="{ 'show-answer': cur == index && showAnswer }"
            >
              <div class="line"></div>
              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/01.png"
                  alt
                />主讲内容
              </div>
              <div class="main-content">
                <div
                  :class="'main-text2'"
                  v-for="i in item.content"
                  :key="i"
                >
                  -{{ i }}<br />
                </div>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/02.png"
                  alt
                />特色亮点
              </div>
              <div class="main-text">
                <p v-for="j in item.light" :key="j">{{ j }}</p>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/03.png"
                  alt
                />可掌握的核心能力
              </div>
              <div class="main-text">
                <p v-for="k in item.ability" :key="k">{{ k }}</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <div class="btn" @click="openDetail">了解详细课程大纲</div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      subject: [
        {
          stage: '第一阶段',
          title: '鸿蒙基础',
          content: [
            '鸿蒙基础语法', 
            'ArkUI', 
            'ArkTS核心', 
            '配套案例'
          ],
          light: [
            '1. 适合零基础学员，从零构建知识体系，循序渐进没有废话，更短时间教会更实用的技术',
            '2. 知识点精雕细琢，结构化表达容易理解，深入浅出知其所以然',
            '3. 案例来源大厂业务，知识落地在主流核心的业务上，直接掌握核心解决方案'
          ],
          ability: [
            '1. 掌握鸿蒙开发环境配置',
            '2. 掌握运算符、表达式、流程控制、函数、数组、对象等的使用',
            '3. 掌握 DevEco Studio 使用小技巧，预览器使用、调试小技巧',
            '4. 掌握ArtTS声明式UI的使用',
            '5. 能够构建鸿蒙UI布局，并于预览器展示'
          ]
        },
        {
          stage: '第二阶段',
          title: '鸿蒙应用开发核心',
          content: [
            '基础组件及容器组件、UI复用',
            '组件化及组件状态',
            '用户输入、动画',
            'ArkTS 进阶',
            '多页面、生命周期',
            'Stage模型核心',
            '应用状态管理、设计资源',
            '网络通讯、JSON',
            'Promise、async',
          ],
          light: [
            '1. 知识体系完整，包含应用开发所有核心知识，且配套对应的实战案例',
            '2. 案例来源大厂APP，知识落地在主流核心的业务上，直接掌握核心解决方案',
            '3. 学习主流网络通信技术，适用于不同的客户端和服务端的通信方案'
          ],
          ability: [
            '1. 掌握鸿蒙开发UI复用的各种技巧',
            '2. 掌握组件状态和应用状态的使用',
            '3. 掌握 Stage 模型和 Ability 组件知识',
            '4. 掌握各类动画在对应场景下运用',
            '5. 掌握应用开发所必备的所有基础',
            '6. 掌握鸿蒙开发中网络通信方案',
            '7. 熟悉异步编程和性能和异常处理技巧',
            '8. 掌握网络基础知识、能够进行网络编程，了解HTTP协议，JSON',
            '9. 掌握ArkTS核心语法及网络编程完成各大APP的核心业务开发'
          ]
        },
        {
          stage: '第三阶段',
          title: '鸿蒙原生APP开发',
          project: [
            {
              title: '面试通',
              content: [
                '基于 window 沉浸式UI界面开发',
                '基于 colorMode 的暗黑主题开发',
                '基于 ability 生命周期数据埋点',
                '基于 preferences 本地持久化',
                '基于 Media Kit 的音频录制和播放',
                '基于 openharmony 的第三方共享包使用开发',
                '基于 axios 三方库的网络资源请求',
                '项目通用工具和组件的封装能力',
                '基于 bundleManager 的应用信息管理',
                '以及 fileIo 核心模块的应用缓存管理',
                '基于 ArkData 的数据库数据存储',
                '基于 Scan Kit 的摄像头扫码',
                '基于 abilityAccessCtrl 的应用权限管理',
                '基于 Image Kit 实现图片处理',
                '基于 bundleManager 实现应用包信息获取',
                '鸿蒙原生APP发布上架'
              ],
              light: [
                '1.应用已上架鸿蒙原生系统华为应用商店',
                '2. 2024 HarmonyOS 创新赛二等奖作品',
                '3. 孵化一个 openharmony 第三方中心仓流行的日历组件',
                '4. 集成鸿蒙系统能力，接入基础服务、网络服务、协同服务、状态栏开放服务、传感器服务等',
                '5. 集成鸿蒙媒体能力，接入音频服务、相机服务、图片处理服务、媒体服务、扫码服务、调测调优服务等',
                '6. 基础鸿蒙应用框架能力，接入程序框架服务、方舟数据管理、文件基础服务、进程间通信服务、本地化开发服务等'
              ],
              ability: [
                '1. 掌握基于 window 沉浸式UI界面开发能力',
                '2. 掌握基于 colorMode 的暗黑主题开发能力',
                '3. 掌握基于 ability 生命周期数据埋点能力',
                '4. 掌握基于 preferences 本地持久化能力',
                '5. 掌握基于 Media Kit 的音频录制和播放能力',
                '6. 掌握基于 openharmony 的第三方共享包使用开发能力',
                '7. 掌握基于 axios 三方库的网络资源请求能力',
                '8. 掌握项目通用工具和组件的封装能力',
                '9. 掌握基于 bundleManager 的应用信息管理能力',
                '10. 掌握以及 fileIo 核心模块的应用缓存管理能力',
                '11. 掌握基于 ArkData 的数据库数据存储能力',
                '12. 掌握基于 Scan Kit 的摄像头扫码能力',
                '13. 掌握基于 abilityAccessCtrl 的应用权限管理能力',
                '14. 掌握基于 Image Kit 实现图片处理能力',
                '15. 掌握Git版本控制',
              ]
            },
            {
              title: '神领物流',
              content: [
                '大型项目基础架构及目录的设计及拆分',
                '封装统一的可上传 可显示 可预览的统一图片上传组件',
                '大量复用自身封装的UI底层组件进行项目快速开发',
                '完整的司机端流程提货-接货-上报异常-回车登记业务',
                '混合开发双向通信机制的标准开发',
                '定位及传导web端定位需求',
                '定制化开发基础系统UI层基础层的基础组件'
              ],
              light: [
                '1.大型项目基础架构及目录的设计及拆分',
                '2.封装统一的可上传 可显示 可预览的统一图片上传组件',
                '3.大量复用自身封装的UI底层组件进行项目快速开发',
                '4.完整的司机端流程提货-接货-上报异常-回车登记业务',
                '5.混合开发双向通信机制的标准开发',
                '6.定位及传导web端定位需求',
                '7.定制化开发基础系统UI层基础层的基础组件'
              ],
              ability: [
                '1. 能够掌握实现鸿蒙app应用搭建项目的基础架构',
                '2. 能够掌握封装鸿蒙基础组件的开发能力',
                '3.能够掌握封装底层网络请求的能力',
                '4. 能够掌握封装统一上传组件及预览图片的能力',
                '5. 能够掌握Ability拉起调度并实现传值的能力',
                '6. 能够掌握音频播放控制的能力',
                '7. 能够掌握消息通知发送及接收的能力',
                '8. 能够掌握混合开发双向通信的开发能力',
                '9. 能够掌握地理位置定位及采用混合开发定位高德地图的能力',
                '10. 能够掌握自定义弹窗插槽传入的开发能力',
                '11. 能够掌握自定义系统UI日期弹窗的能力'
              ]
            }
          ]
        },
        {
          stage: '第四阶段',
          title: '鸿蒙一次开发多端部署App开发',
          project: [
            {
              title: '美蔻商城',
              content: [
                'AGC平台、一多开发、界面一多、功能一多、工程一多、静态三层架构',
                '自适应、响应式、栅格系统、项目适配',
                'logger工具、axios封装',
                'LazyForEach、MkCell组件、MkCellGroup组件、锚点定位、Sku组件、MkDialogLoading组件',
                'audioCapturer录音、asrEngine语音识别、AccountKit华为登录、签名证书、生成秘钥、调试证书、调试profile、配置公钥指纹',
                'MkEmpty组件、购物车、支付宝支付',
                'LocationButton地理位置、LocationKit地址解析、即时通信、Web组件协议拦截',
                'MkTabs组件、服务卡片、卡片拉起、通知卡片 ',
                'MapKit华为地图、路径规划、绘制线、绘制标记',
                '使用AI工具 CodeGenie 生成推荐商品卡片',
                '基于 User Authentication Kit 实现华为账号一键登录'
              ],
              light: [
                '1. 2024 HarmonyOS 创新赛 TOP50 入围奖作品',
                '2. AI辅助开发，代码翻译、代码生成、卡片生成，高效开发',
                '3. 一次开发多端部署，三层架构、界面一多、能力适配、web支付',
                '4. 全面集成HMS能力，接入华为地图、华为登录、分享扫码等',
                '5. 鸿蒙原生AI能力，接入基础语音服务、自然语言理解服务、基础视觉服务等'
              ],
              ability: [
                '1. 掌握运用AI工具提高开发效率的能力',
                '2. 掌握一次开发多端部署三层架构能力',
                '3. 掌握使用华为账号服务实现华为登录',
                '4. 掌握使用华为地图服务实现物流轨迹绘制',
                '5. 掌握使用华为分享服务实现商品海报分享',
                '6. 掌握使用华为扫码服务实现商品搜索',
                '7. 掌握使用基础语音AI服务实现语音搜索',
                '8. 掌握卡片和宿主应用的数据通信能力',
              ]
            },
            {
              title: '黑马云音乐',
              content: [
                '项目架构-工程资源准备、AVPlayer工作模式和状态机',
                '播放功能-播放功能、切换播放模式',           
                '播放功能-断点续播、缓存播放、功能完善与性能调优',
                '卡片-卡片ID存储方案、解决播放器通知卡片缺陷',
                '卡片-下载网络图片、卡片通知应用',
                '鸿蒙- 密钥-证书-签名、生成密钥和证书请求文件',
                '编译构建.app文件、上架.app'
              ],
              light: [
                '【AVPlayer】对状态机进行二次封装管理，实现播放模式控制、列表播放等功能',
                '【控制中心】音频播放接入控制中心，进行系统播放控制通知',
                '【后台播放】应用支持后台运行，防墓碑机制',
                '【个性动画】破坏风文字抖动、霓虹呼吸灯等动画效果',
                '【图片下载】对图片进行沙箱缓存，下载方案优化等',
                '【应用通信】实现控制中心、线程、进程之间通信方案并进行二次封装',
                '【音频合成】PCM格式音频录入、媒体类型转化、多音轨合成方案'
              ],
              ability: [
                '1、掌握基于鸿蒙@ohos.animator进行播放动画同步',
                '2、掌握基于元服务进行卡片播放同步',
                '3、掌握基于AVPlayer媒体资源转码并通过输出设备播放',
                '4、掌握应用卡片添加、卡片通信、状态通知',
                '5、掌握状态持久化、后台任务创建销毁'
              ]
            }
          ]
        },
        {
          stage: '第五阶段',
          title: '鸿蒙混合开发APP',
          content: [
            '混合开发介绍',
            '前端基础',
            'Vue3 核心技术',
            '鸿蒙混合开发-美蔻商城个人中心',
          ],
          light: [
            '1. 全面覆盖前端流行最新技术，使用 Vue3+TS 技术栈开发',
            '2. 从原生侧到H5侧全面讲解，独立封装 JSBridge 给  Web 侧使用',
            '3. 基于 mk.queryUser 使用鸿蒙侧用户认证信息',
            '4. 基于 mk.pickerCamera 调用鸿蒙侧项目拍照',
            '5. 基于 mk.pickerPhoto 调用鸿蒙侧相册图片',
            '6. 基于 mk.vibrator 调用鸿蒙侧传感器马达',
            '7. 基于 mk.getAreaColumns 获取鸿蒙侧本地化城市数据',
            '8. 基于 mk.getLocations 调用鸿蒙侧地理定位'
          ],
          ability: [
            '1. 掌握前端核心技术独立开发H5项目',
            '2. 掌握前端主流框架 Vue 高效开发前端项目',
            '3. 掌握 JSBridge 技术完成鸿蒙混合应用开发',
          ]
        },
        {
          stage: '第六阶段',
          title: 'Flutter跨平台开发',
          content: [
            'Flutter跨平台开发',
            '享+生活项目-网络请求',
            '享+生活项目-消息反馈',
            '享+生活项目-公告管理',
            '享+生活项目-登录检测&用户登录',
            '享+生活项目-个人资料',
            '享+生活项目-房屋管理',
          ],
          light: [
            '1. 跨平台开发（一套代码打包原生鸿蒙、安卓、iOS、Web）',
            '2. 基于常用的Widget二次封装和通用组件封装',
            '3. 全局状态和路由, 基于GetX完成了OBS状态动态更新 , 采用GetMaterialApp进行路由系统全局预配置',
            '4. 基于 dio 网络工具库二次封装，统一配置请求与响应拦截，为外部提供各类请求方法',
            '5. 基于 EventBus 封装全局单例对象，实现多处跨页面消息事件传递，优化页面间通信机制',
            '6. 结合高德地图与经纬度信息，完成逆地理编码和周边 POI 搜索',
            '7. 基于provide实现多Widget、多页面数据实时修改和共享',
            '8. 利用 flutter_html 三方库实现富文本内容加载与渲染'
          ],
          ability: [
            '1. 掌握 Dart 核心语法具备 Flutter 应用开发能力',
            '2. 掌握 Flutter 跨平台能力开发鸿蒙APP能力'
          ]
        },
        {
          stage: '第七阶段',
          title: '鸿蒙万物互联App开发',
          project: [
            {
              title: '翼康养老',
              content: [
                '@itheima/wing-care组件库、动态三层架构',
                '华为IOT云平台、Auth鉴权、华为登录、折线图',
                '设备安装、设备绑定',
                '蓝牙扫描、蓝牙授权、蓝牙开关',
                'Mac地址配对、设备解绑、血糖仪、ble蓝牙通信、华为云IoTDA、https协议接入',
                '智能门禁、WIFI权限、WIFI检查、门禁配网、蓝牙开门、摇一摇开门、临时密码'
              ],
              light: [
                '1. 2024华为跑跑码特大赛获唯一一等奖作品',
                '2. 动态三层架构项目，掌握项目架构能力，才能从根上优化项目',
                '3. 基于华为IOT云平台物联网项目，设备侧应用侧服务侧全链路打通',
                '4. 穿插各种端侧通信技术，物联网最佳实战APP'
              ],
              ability: [
                '1. 能够独立开发APP核心业务能力',
                '2. 掌握基于IOT云平台的物联网项目开发',
                '3. 掌握应用侧 HTTPS 协议上报IOT设备数据',
                '4. 掌握应用侧通过 BLE 蓝牙协议与IOT设备通信',
                '5. 掌握应用侧通过IOT云平台下发IOT设备指令',
                '6. 掌握使用 @ohos/crypto-js 实现数据加密处理',
                '7. 掌握使用华为账号服务实现华为登录',
                '8. 掌握基于蓝牙和传感器实现摇一摇开门'
              ]
            },
            {
              title: '守护助手',
              content: [
                '权限列表、权限组、权限等级、权限工作流、系统设置',
                '应用信息、硬件信息、地理位置信息、设备标识符',
                '网络类型、WiFi 信息、IP 地址、Mac 地址、Socket 通讯',
                '录音、拍照、扫码',
                '图片库、视频库、音频库、文件库',
                '打电话、短信、通讯录、通话记录、日历信息',
                '数据安全、隐私空间、身份认证、加密、解密、压缩',
                '通知、后台任务、剪贴板、陀螺仪、马达、电量、流量',
                '本地数据库、并发、多线程、文件读写、崩溃数据采集'
              ],
              light: [
                '1.【隐私空间】通过 手势/指纹/面容ID 进行验证，加密存储照片、视频、录音、笔记确保隐私安全。',
                '2.【照片清理】定期清理相似或连拍照片，压缩手机中的大图片，解决手机空间不够用的烦恼。',
                '3.【联系人同步】通讯录一键体检优化，清理异常联系人，一键同步和恢复通讯录。',
                '4.【夜路守护】夜路导航，位置分享实时行踪监控，亲友同步，附近派出所提供 110 对接。',
                '5.【室内守护】伪装声音，伪装来电保护隐私，隐瞒独身，虚拟警报器，手机移动检测功能。',
                '6.【日历清理】添加重要日程，清理过期日程。',
                '7.【硬件信息】查询手机的型号，系统版本，启动时长，网络信息，剩余存储，传感器硬件支持情况。',
                '8.【权限管理】一键开启通知、位置、通讯录、相机、照片、麦克风、日历权限。',
                '9.【用户体验改进】应用崩溃时自动上传错误日志，监控应用安全运行。'
              ],
              ability: [
                '1. 能够使用 Network Kit 获取网络信息',
                '2. 能够使用 Sensor Service Kit 检测传感器支持情况',
                '3. 能够使用 User Authentication Kit 实现指纹/面容ID/PIN密码解锁',
                '4. 能够使用 ArkData API 实现关系型数据库的增删查改',
                '5. 能够使用 Media Library Kit 读写系统相册',
                '6. 能够使用 Calendar Kit 清理过期日程',
                '7.  能够使用 Telephony Kit 拨打紧急电话',
                '8. 能够使用 Contacts Kit 操作通讯录',
                '9. 能够使用 Performance Analysis Kit 获取故障日志'
              ]
            }
          ]
        },
        {
          stage: '第八阶段',
          title: 'uniapp跨平台开发',
          content: [
            '优医问诊',
            'uni-app项目创建；命令式安装；uni-ui组件库；Pinia持久化',
            '第三方登录；账号密码登录；短信验证码登录',
            '文件上传拦截器；第三方支付；支付跳转；支付回调',
            '物流轨迹；即时通信',
            '首页；极速问诊；选择医院',
            '选择科室；选择患者；填写病情；支付诊费；问诊室聊天',
            '开处方；购买药品；药品物流'
          ],
          light: [
            '1.【最新技术栈】Vue3+TS+Pinia 前端最新最流行的技术栈',
            '2.【即时通信】基于 SocketIO 实现医生在线诊室医患聊天',
            '3.【高德地图】基于 AMap 路径规划、路径绘制实现物流',
            '4.【支付宝支付】基于支付宝沙箱支付实现问诊费用支付',
            '5.【跨平台开发】基于uni-app实现多端开发适配各类终端'
          ],
          ability: [
            '1. 掌握 uni-app 跨平台开发技术完成小程序和APP开发',
            '2. 掌握前端支付、即时通信、地图等主流业务方案',
            '3. 掌握uni-app跨平台开发框架核心使用',
            '4. 掌握运用uni-app插件市场完成业务逻辑开发',
            '5. 掌握微信支付和微信登录第三方能力调用',
            '6. 基于vue3+ts以及周边生态完成项目开发',
            '7. 能够运用小程序云开发完成项目相关业务',
            '8. 能够基于websocket实现即时通信问诊室',
            '9. 能够给予第三方地图完成药品物流轨迹绘制'
          ]
        },
        {
          stage: '第九阶段',
          title: '元服务+端云一体',
          content: [
            'AGC控制台',
            '端云一体化开发流程',
            '云函数开发',	
          ],
          light: [
            '1. 端云一体开发接入 AGC Serverless 云服务，实现后台接口开发免运维，助力鸿蒙高效开发',
            '2. 元服务轻量应用程序形态，具备服务直达、跨设备等特征',
          ],
          ability: [
            '1. 掌握鸿蒙元服务独立开发能力',
            '2. 掌握鸿蒙应用端侧和云侧的需求开发能力',
            '3. 掌握使用SDK操作云函数、云数据库、云存储能力',
          ]
        },
        {
          stage: '第十阶段',
          title: '简历指导&模拟面试',
          content: [
            '简历指导',
            '面试专题库',
            '模拟面试',
            '面试指导	'
          ],
          light: [
            '1. 将面试指导贯穿阶段始终，循序渐进提高技术、项目专业度',
            '2. 一对一企业模拟面试，全方位指导',
            '3. 高质量行业标准简历库',
            '4. 专项项目课程，面试跟踪与复盘',
            '5. 内推鸿蒙生态岗位'
          ],
          ability: [
            '1. 用科学方法循序渐进模块化简历书写',
            '2. 高质量行业标准简历库累积，让学员简历技术专业度、项目专业度、经验专业度提挡提质',
            '3. 一对一企业模拟面试，全方位指导、帮扶面试过程核心问题及解决措施',
            '4. 提升项目表达与项目业务专业度'
          ]
        },
      ],

      cur: -1,
      selCur: 0,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
         this.clickZiXun()
      }
      this.mai("鸿蒙-就业课","了解详细课程大纲",0,null)
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      // console.log(this.$refs.item[index]);
      // console.log(this.$refs.item[index].offsetTop, this.prevItemHeight);
      this.goTop(index);
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    changeSelCur(index) {
      this.selCur = index;
    }
  },
};
</script>

<style lang="less" scoped>
.box4 {
  width: 750px;
  padding-top: 80px;
  background: linear-gradient(0deg, #DBE1FF 0%, #FFFFFF 50%, #DBE1FF 100%);
  .box4-btm-box {
    padding-bottom: 80px;
    width: 100%;
    padding-top: 48px;
  }

  .btn {
    margin: 50px auto 0;
    width: 570px;
    height: 88px;
    background: linear-gradient(0deg, #FF6C47 1%, #FF5A47 100%);
    border-radius: 44px;
    font-weight: 600;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 22px 0px 22px 35px;
    padding-right: 22px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    justify-content: space-between;

    .title {
      margin-right: 20px;

      display: flex;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #020941;
      line-height: 40px;
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 40px;
        color: rgba(64, 128, 255, 1);
        margin-right: 16px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 24px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;
    padding: 0px 30px 0px;

    .line {
      margin-bottom: 28px;
      width: 622px;
      height: 1px;
      margin-left: -8px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 30px 0px;
    border-radius: 16px;
    // display: block;
    max-height: 3000px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;
    img {
      margin-right: 14px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 24px;
    margin-left: 45px;
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 16px;
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }
  }

  .main-text {
    margin-bottom: 40px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    margin-left: 45px;
 
    p{
         text-indent: -31px;
    padding-left: 31px;
    }
  }
  .main-text2 {
    margin-bottom: 16px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
  }

  .sel-wrapper{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 30px 0;
    font-size: 24px;
    color: #002BFF;
    font-weight: 600;
    .sel{
      padding: 10px 30px;
      border: 4px solid #002BFF;
      border-radius: 15px;
      margin-right: 36px;
    }
    .active{
      color: #fff;
      background: #002BFF;
    }
  }
}
</style>
